import { createContext, useReducer } from "react";
import React from 'react';

export const ThemeContext = createContext();

const INITIAL_STATE = { 
  darkMode: true,
  theme: 'professional' // mature, professional theme
};

const themeReducer = (state, action) => {
  switch (action.type) {  
    case "TOGGLE_DARK":
      return { ...state, darkMode: !state.darkMode };
    case "SET_THEME":
      return { ...state, theme: action.payload };
    default:
      return state;
  }
}; 

export const ThemeProvider = (props) => {
  const [state, dispatch] = useReducer(themeReducer, INITIAL_STATE);
  
  // sync class for Tailwind dark mode - runs after state updates
  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      if (state.darkMode) {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
      } else {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add('light');
      }
      
      // Add professional theme class for styling
      document.documentElement.setAttribute('data-theme', state.theme);
    }
  }, [state.darkMode, state.theme]);

  return (
    <ThemeContext.Provider value={{state, dispatch}}>{props.children}</ThemeContext.Provider>
  );
};
